import { BookingOverview } from './../models/booking-overview.model';
import { SearchBookingModel } from './../models/search-booking.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'wego-confirm-booking',
  template: require('../views/confirm-booking.component.html'),
  styles: [`
    span.label.label-default{
      font-size: 13px;
      line-height: 35px;
      background-color: #eeeeee;
      color: #2BA2AA;
      margin-right: 5px;
    }
    
    span.label.label-default.text-success{
      color: #3c763d;
    }
    
    span.label.label-default.text-danger{
      color: #a94442;
    }
          `
  ]
})
export class ConfirmBookingComponent implements OnInit {
  @Input('BookingOverview') bookingOverview: BookingOverview;
  @Input('BookingRemarks') bookingRemarks: string;
  @Output('OnConfirmBooking') onConfirmBooking = new EventEmitter();
  @Output('OnCancelBooking') onCancelBooking = new EventEmitter();

  //bookingRemarks: string;

  constructor(private locationService: Location) { }

  ngOnInit() { }

  private OnConfirmBooking($event: any) {
    this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
  }

  private OnCancelBooking($event: any) {
    this.onCancelBooking.emit($event);
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = 'vehicleAttributeCategoryName';
      return vehicleAttributeList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/confirm-booking.component.ts